// extracted by mini-css-extract-plugin
export default {"friends-list__friend":"FriendsList_friends-list__friend__VYMEm"};